// NETWORK ERRORS
export const NETWORK_ERROR_INVALID_REQUEST = "invalid_request";

// FILTER TYPES
export const CHECKBOX = "checkbox_list";
export const SWITCH = "switch";
export const RADIO = "radio";
export const BOOLEAN = "boolean";
export const NUMBER = "number";
export const RANGE = "range";
export const TEXT = "text";

// HTTP METHODS
export const HTTP_GET = "get";
export const HTTP_POST = "post";
export const HTTP_PUT = "put";
export const HTTP_DELETE = "delete";

// MAIL ADDRESSES
export const ELISO_MAIL_ADDRESS = "info@cosmix.io";

export const PRICE_FORMAT = "0,0[.]00$";

// Account update errors

export const ERROR_UPDATE_ACCOUNT_TOO_MANY_USERS_FOR_OPERATION = "TOO_MANY_USERS_FOR_OPERATION";
